
export function jsonFormData(config){
  const formData = new FormData();
  //循环传入的值转换formData
  Object.keys(config).forEach((key) => {
    formData.append(key, config[key]);
  })
  return formData;
}
// 当前时间
export function nowTime(num) {
  let yy = new Date().getFullYear();
  let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
  let dd = (new Date().getDate()) < 10 ? '0' + (new Date().getDate()) : (new Date().getDate());
  let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
  if(num == 1){
    return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
  }else if(num == 2){
    return yy + '-' + mm;
  }
}

// 日期转换
export function timeDay(time,num){
  var date = new Date(time);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  var s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  if(num == 1){
    return y + "-" + m + "-" + d+ ' ' + h + ':' + minute + ':' + s;
  }else if(num == 2){
    return y + "-" + m
  }else{
    return y + "-" + m + "-" + d
  }
}
// 遍历数组返回id或者item
export function forinlist(list,num){
  let idlist = [];
  let inlist = [];
  list.forEach(item => {
    idlist.push(item.id);
    inlist.push(item);
    if(item.children && item.children.length > 0){
      item.children.forEach(itemtwo =>{
        idlist.push(itemtwo.id);
        inlist.push(itemtwo);
        if(itemtwo.children && itemtwo.children.length > 0){
          itemtwo.children.forEach(itemthr =>{
            idlist.push(itemthr.id);
            inlist.push(itemthr);
          })
        }
      })
    }
  })
  if(num == 1){
    return idlist;
  }else if(num == 2){
    return inlist;
  }
}

